/* RunNetworkDiscoveryAction.js */

"use strict";

class RunAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        activeView,
        userSession,
        NetworkDiscoveryPlan
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._NetworkDiscoveryPlan = NetworkDiscoveryPlan;

        this._selectedPlan = this._gameEditor._networkDiscoveryPlanEntity;

        this.run = this.run.bind(this);
    }

    run() {
        return this._selectedPlan
            .runNetworkDiscoveryWork({autoAddDevices: false}, {})
            .then((results) => {
                if (results.errorMsg) {
                    return this._modalUserFeedback.displayError({
                        error: {errorMsg: results.errorMsg},
                    });
                }
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                return this._modalUserFeedback.displayError({error: {errorMsg: err}});
            });
    }
}

module.exports = RunAction;

RunAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.NetworkDiscoveryPlan",
];

RunAction.$displayDetails = {
    type: "Action",
    name: "RunNetworkDiscovery",
    icon: "networkdiscovery.run_network_discovery",
    shown: true,
    title: "Run Discovery Plan",
    order: 1,
};
